import React from 'react';
import * as d3 from 'd3';

export const useD3 = (renderChartFn, dependencies) => {
    const ref = React.useRef();

    React.useEffect(() => {
        const svg = d3.select(ref.current);
        svg.selectAll('*').remove();  // Clear the SVG content before rendering
        renderChartFn(svg);
        return () => {};
    }, dependencies);

    return ref;
}